import { FunctionComponent } from 'react'
import { TSelectableItemProps, createSelectable } from 'react-selectable-fast'
import { Check, Add } from '@mercadoni/gungnir'

const EDIT = 'edit'
const VIEW = 'view'

export declare type Mode = 'view' | 'edit'

export type SelectableQuotaProps = {
  index?: number
  isSelected?: boolean
  isActiveQuota?: boolean
  selectableRef?: TSelectableItemProps['selectableRef']
  mode?: Mode
  fleetQuota?: any
  date?: string
  hour?: number
  className?: string
}

const SelectableQuota: FunctionComponent<TSelectableItemProps & SelectableQuotaProps> = ({
  index,
  selectableRef,
  isSelected,
  isActiveQuota,
  fleetQuota,
  mode,
  className = ''
}: SelectableQuotaProps): JSX.Element => {
  let cssClass = `gungnir-rqc-quotas ${className}`
  if (!isActiveQuota) cssClass += 'in-active-quota '
  if (mode === EDIT && isSelected && isActiveQuota) cssClass += 'selected-quota '
  if (mode === VIEW) cssClass += 'not-selectable'
  return (
    <div ref={selectableRef} key={index} className={cssClass}>
      <div className='gungnir-rqc-quota'>
        {fleetQuota ? (
          <span className='gungnir-rqc-quota-element'>
            <div className='tooltip'>
              <Check style={{ color: fleetQuota?.fleet?.color }} />
              <span className='tooltip-text'>{fleetQuota?.fleet?.name}</span>
            </div>
          </span>
        ) : mode === EDIT && isActiveQuota ? (
          <Add />
        ) : null}
      </div>
    </div>
  )
}

export default createSelectable(SelectableQuota)
